const { liveActionTypes } = require("./actionTypes");

const initialState = {
  connected: false,
  byIds: {},
  byContestIds: {},
};

const upsert = (state, payload) => {
  let data = payload;
  if (!Array.isArray(payload)) {
    data = [payload];
  }

  const byIds = {
    ...state.byIds,
  };
  const updateProbe = (item) => {
    byIds[item.id] = {
      ...(state?.byIds?.[item?.id] ?? {}),
      ...item,
    };
  };
  data.forEach(updateProbe);

  return byIds;
};

const upsertContest = (state, payload) => {
  let data = payload;
  if (!Array.isArray(payload)) {
    data = [payload];
  }

  const byContestIds = {
    ...state.byContestIds,
  };
  const updateProbe = (item) => {
    byContestIds[item.id] = {
      ...(state?.byContestIds?.[item?.id] ?? {}),
      ...item,
    };
  };
  data.forEach(updateProbe);

  return byContestIds;
};

export const liveReducer = (state = initialState, action) => {
  switch (action.type) {
    case liveActionTypes.SET_STATUS:
      return {
        ...state,
        connected: action.status,
      };
    case liveActionTypes.SET_WS_REF:
      return {
        ...state,
        wsRef: action.wsObj,
      };

    case liveActionTypes.CLEAR_DATA:
      return {
        ...state,
        byIds: {},
      };
    case liveActionTypes.RECEIVE_MESSAGE:
      return {
        ...state,
        byIds: upsert(state, action.data),
      };
    case liveActionTypes.CONTEST_RECEIVE_MESSAGE:
      return {
        ...state,
        byContestIds: upsertContest(state, action.data),
      };

    case liveActionTypes.CONTEST_CLEAR_DATA:
      return {
        ...state,
        byContestIds: {},
      };

    default:
      return state;
  }
};
